import { Component, EventEmitter, Input, Output } from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import { FormatHelperService } from '@shared/services/format-helper.service';

@Component({
    selector: 'app-history-dossier-modal',
    templateUrl: './history-dossier-modal.component.html',
    animations: modalAnimations,
})
export class HistoryDossierModalComponent {
    @Input() visibility: boolean;
    @Input() dossier: ContextDossier;
    @Output() visibilityChange = new EventEmitter<boolean>();

    idSousDossier: string;
    listeStatutDA = [];

    constructor() {
        //do nothing
    }

    /**
     * Retourne la liste totale des statuts de la propositions courantes et des propositions sans suite pour affichage dans la modal
     */
    getlisteStatutDA() {
        if (
            this.dossier &&
            (!this.idSousDossier ||
                this.idSousDossier !==
                    this.dossier.emprunteur.idSousDossier.toString())
        ) {
            this.idSousDossier =
                this.dossier.emprunteur.idSousDossier.toString();
            this.listeStatutDA = [];
            this.populateListeStatutDAfromAssurance(
                this.dossier.emprunteur.currentAssurance,
                this.listeStatutDA
            );
            if (this.dossier.emprunteur.listeAssuranceSansSuite) {
                for (const assurance of this.dossier.emprunteur.listeAssuranceSansSuite.reverse()) {
                    this.populateListeStatutDAfromAssurance(
                        assurance,
                        this.listeStatutDA
                    );
                }
            }
        }

        return this.listeStatutDA;
    }

    /**
     * Prepare la liste des statuts d une assurance pour affichage dans la modal
     *
     * @param assurance
     * @param listeStatutDA
     */
    populateListeStatutDAfromAssurance(assurance, listeStatutDA): void {
        const statutDAForSSM = ['FC', 'CB'];

        if (assurance.listeStatutsDA) {
            for (const statutDA of assurance.listeStatutsDA.reverse()) {
                statutDA.dateFormatted =
                    FormatHelperService.getDateFormattedFromTimestamp(
                        statutDA.dateValidite
                    );
                statutDA.ssm = '';
                if (
                    this.dossier.emprunteur.topSansSelectionMedicale &&
                    statutDAForSSM.includes(statutDA.daCode)
                ) {
                    statutDA.ssm = '.SSM';
                }

                listeStatutDA.push(statutDA);
            }
        }
    }

    /**
     * Modifie le boolean visibility pour fermer la modal
     */
    close() {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
    }
}
